export const propertyValueTypes = {
  string: 'STRING',
  decimal: 'DECIMAL',
  integer: 'INT',
  boolean: 'BOOL',
  dictionary: 'DICTIONARY',
};

export const labelPropertyTypes = {
  remote: 'Remote',
  previewText: 'PreviewText',
  serialization: 'Serialization',
  serializationScanCode: 'SerializationScanCode',
  serializationDerivative: 'SerializationDerivative',
  palletQuantity: 'PalletQuantity',
  batchQuantity: 'BatchQuantity',
  consumerUnitEan: 'ConsumerUnitEan',
  tradeUnitEan: 'TradeUnitEan',
};

export default {
  propertyValueTypes,
  labelPropertyTypes,
};
